export default {
    section: 'Employer Information',
    name: 'employment-resources-benefits-information',
    items: [
        {
            type: 'radio-list',
            text: 'Insurance',
            name: 'employment-resources-benefits-information-insurance',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'checkbox-list',
                    text: 'Please select the type of insurance which would apply',
                    name: 'employment-resources-benefits-information-insurance-type',
                    props: {
                        message: 'If you would like to avoid adjustments to employment agreements every time insurance benefits change, consider only listing the type of insurance benefit the employee may be eligible to receive and referring employees to the plan documents for a detailed description of the benefit',
                        items: [
                            {
                                text: 'Health',
                                value: 'health'
                            },
                            {
                                text: 'Dental',
                                value: 'dental'
                            },
                            {
                                text: 'Vision',
                                value: 'vision'
                            },
                            {
                                text: 'Life',
                                value: 'life'
                            },
                            {
                                text: 'Disability',
                                value: 'disability'
                            },
                            {
                                text: 'Other',
                                value: 'other'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-benefits-information-insurance',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Please describe other insurance types',
                    name: 'employment-resources-benefits-information-insurance-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-benefits-information-insurance',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-benefits-information-insurance-type',
                                operator: 'contains',
                                value: 'other'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Retirement Plan',
            name: 'employment-resources-benefits-information-retirement',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'checkbox-list',
                    text: 'Retirement plan options',
                    name: 'employment-resources-benefits-information-retirement-options',
                    props: {
                        items: [
                            {
                                text: 'Refer employees to the plan document for a detailed description (easier in case of benefit changes)?',
                                value: 'refer'
                            },
                            {
                                text: 'Include a more detailed description of the retirement plan benefit in the contract?',
                                value: 'include-details'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-benefits-information-retirement',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Please provide the information to be included',
                    name: 'employment-resources-benefits-information-retirement-options-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-benefits-information-retirement',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-benefits-information-retirement-options',
                                operator: 'contains',
                                value: 'include-details'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Vacation/Sick Leave/PTO',
            name: 'employment-resources-benefits-information-pto',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'checkbox-list',
                    text: 'Vacation/Sick Leave/PTO options',
                    name: 'employment-resources-benefits-information-pto-options',
                    props: {
                        items: [
                            {
                                text: 'Refer employees to existing company policies (e.g., an Employee Handbook) for a detailed description (easier in case of changes)',
                                value: 'refer'
                            },
                            {
                                text: 'Include a more detailed description of the benefit in the contract.',
                                value: 'include-details'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-benefits-information-pto',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Please provide the information to be included',
                    name: 'employment-resources-benefits-information-pto-options-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-benefits-information-pto',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-benefits-information-pto-options',
                                operator: 'contains',
                                value: 'include-details'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Other',
            name: 'employment-resources-benefits-information-other',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'textarea',
                    text: 'Please provide a brief description',
                    name: 'employment-resources-benefits-information-other-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-benefits-information-other',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/employment-resources/valuation-data/benefits-information.js